import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import "./KeyFeatures.css";
const data = [
  {
    id: "01",
    img: "./images/key-features1.png",
    content: "Easy Back testing and Live Scanning",
  },
  {
    id: "02",
    img: "./images/key-features2.png",
    content: "Real time market scanner with multiple time frame analysis",
  },
  {
    id: "03",
    img: "./images/key-features3.png",
    content: "Technical indicator",
  },
  {
    id: "04",
    img: "./images/key-features4.png",
    content: "Automated Strategies",
  },
];
function KeyFeatures() {
  return (
    <>
      <section className="key-features-block">
        <Container>
          <Row className="justify-content-center">
            <Col md={{ span: 12, offset: 0 }} lg={{ span: 10, offset: 1 }}>
              <h3>Key Features</h3>
              <ul>
              {(data === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
                {data.map((data, i) => {
                  return (
                    <li key={i}>
                      <div class="foxTraderkey_group">
                      <div class="foxTraderkey_imgpanel"> 
                      <img src={data.img} alt="img" />
                      </div>
                      <p>{data.content}</p>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default KeyFeatures;
